import React, { useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

/**
 * Mobile-safe wrapper around react-signature-canvas.
 *
 * The raw component keeps its internal bitmap at whatever pixel width/height
 * it was given (default 300x150). Stretching it with CSS (w-full) makes touch
 * coordinates land far from the drawn stroke on phones. This wrapper measures
 * its container and gives the canvas REAL pixel dimensions, and sets
 * touch-action:none so drawing doesn't scroll the page.
 */
export const ResponsiveSignatureCanvas = React.forwardRef(function ResponsiveSignatureCanvas(
  { height = 192, canvasClassName = '', ...props },
  ref
) {
  const wrapRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const measure = () => {
      const w = Math.floor(el.getBoundingClientRect().width);
      if (w > 0) setWidth((prev) => (Math.abs(prev - w) > 2 ? w : prev));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={wrapRef} className="w-full" style={{ touchAction: 'none' }}>
      {width > 0 && (
        <SignatureCanvas
          ref={ref}
          penColor="black"
          backgroundColor="white"
          canvasProps={{
            width,
            height,
            className: `signature-canvas ${canvasClassName}`,
            style: { touchAction: 'none', display: 'block' },
          }}
          {...props}
        />
      )}
    </div>
  );
});

export default ResponsiveSignatureCanvas;
